"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get additionalExcludePropsForCol () {
        return additionalExcludePropsForCol;
    },
    get excludeAttachmentProps () {
        return excludeAttachmentProps;
    },
    get extractAttachmentPropsAndFormat () {
        return extractAttachmentPropsAndFormat;
    },
    get extractColMetaForAudit () {
        return extractColMetaForAudit;
    },
    get extractColsMetaForAudit () {
        return extractColsMetaForAudit;
    },
    get extractExcludedColumnNames () {
        return extractExcludedColumnNames;
    },
    get extractNonSystemProps () {
        return extractNonSystemProps;
    },
    get extractPropsFromPrev () {
        return extractPropsFromPrev;
    },
    get extractRefColumnIfFound () {
        return extractRefColumnIfFound;
    },
    get extractViewRelatedProps () {
        return extractViewRelatedProps;
    },
    get filterAndMapAliasToColProps () {
        return filterAndMapAliasToColProps;
    },
    get formatDataForAudit () {
        return formatDataForAudit;
    },
    get fromEntries () {
        return fromEntries;
    },
    get generateAuditV1Payload () {
        return generateAuditV1Payload;
    },
    get generateUpdateAuditV1Payload () {
        return generateUpdateAuditV1Payload;
    },
    get mapAlias () {
        return mapAlias;
    },
    get parseMetaIfFound () {
        return parseMetaIfFound;
    },
    get populateUpdatePayloadDiff () {
        return populateUpdatePayloadDiff;
    },
    get remapWithAlias () {
        return remapWithAlias;
    },
    get removeBlankPropsAndMask () {
        return removeBlankPropsAndMask;
    },
    get transformToSnakeCase () {
        return transformToSnakeCase;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _deepobjectdiff = require("deep-object-diff");
const _models = require("~/models");
const _extractProps = require("~/helpers/extractProps");
const _datatransformationbuilder = require("~/utils/data-transformation.builder");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function fromEntries(entries) {
    return entries.reduce((acc, entry)=>{
        if (!entry) return acc;
        const [key, value] = entry;
        acc[key] = value;
        return acc;
    }, {});
}
const removeBlankPropsAndMask = (obj, _excludedProps = [], includeNull = false, includeBlanks = false)=>{
    const excludedProps = [
        ..._excludedProps,
        'created_at',
        'updated_at',
        'base_id',
        'source_id',
        'fk_workspace_id'
    ];
    if (obj === null || obj === undefined) return obj;
    return fromEntries(Object.entries(obj).filter(([key, value])=>(includeNull || value !== null) && value !== undefined && (includeBlanks || value !== '') && (!excludedProps || !excludedProps.includes(key))));
};
const systemColumns = [
    'created_at',
    'updated_at',
    'id',
    'base_id',
    'fk_workspace_id',
    'source_id',
    'is_deleted',
    'created_by',
    'updated_by',
    'deleted',
    'fk_model_id'
];
const extractPropsFromPrev = (prev, next)=>{
    if (!prev || !next) return next;
    return fromEntries(Object.entries(next).map(([key])=>[
            key,
            prev[key]
        ]));
};
function extractNonSystemProps(payload, additionalExcludeProps = [], includeNulls = false) {
    if (!payload || typeof payload !== 'object') return payload;
    return fromEntries(Object.entries(payload).filter(([key, val])=>{
        return (includeNulls || val !== null) && !systemColumns.includes(key) && !(additionalExcludeProps == null ? void 0 : additionalExcludeProps.includes(key));
    })// remove fk_ prefix
    .map(([key, val])=>{
        return [
            key.replace(/^fk_/, ''),
            val
        ];
    }));
}
async function generateAuditV1Payload(opType, params) {
    var _ref, _params_fk_workspace_id, _ref1, _params_base_id, _ref2, _params_source_id, _params_fk_model_id, _ref3;
    var _req_user, _req_user1, _req_headers;
    const { details, context, req, id } = params;
    // todo: handle it in a better way
    // if payload includes view_id and view_title and not table_title, then extract table_title
    if (details && !details.table_title && (params.fk_model_id || (context == null ? void 0 : context.fk_model_id))) {
        var _params_fk_model_id1;
        var _this;
        details.table_title = (_this = (req == null ? void 0 : req.ncModel) || await _models.Model.get(context, (_params_fk_model_id1 = params.fk_model_id) != null ? _params_fk_model_id1 : context == null ? void 0 : context.fk_model_id)) == null ? void 0 : _this.title;
    }
    return {
        user: req == null ? void 0 : (_req_user = req.user) == null ? void 0 : _req_user.email,
        ip: req == null ? void 0 : req.ip,
        fk_user_id: req == null ? void 0 : (_req_user1 = req.user) == null ? void 0 : _req_user1.id,
        user_agent: req == null ? void 0 : (_req_headers = req.headers) == null ? void 0 : _req_headers['user-agent'],
        fk_workspace_id: (_ref = (_params_fk_workspace_id = params.fk_workspace_id) != null ? _params_fk_workspace_id : context == null ? void 0 : context.workspace_id) != null ? _ref : req == null ? void 0 : req.ncWorkspaceId,
        base_id: (_ref1 = (_params_base_id = params.base_id) != null ? _params_base_id : context == null ? void 0 : context.base_id) != null ? _ref1 : req == null ? void 0 : req.ncBaseId,
        source_id: (_ref2 = (_params_source_id = params.source_id) != null ? _params_source_id : context == null ? void 0 : context.source_id) != null ? _ref2 : req == null ? void 0 : req.ncSourceId,
        fk_model_id: (_params_fk_model_id = params.fk_model_id) != null ? _params_fk_model_id : context == null ? void 0 : context.fk_model_id,
        row_id: (_ref3 = context == null ? void 0 : context.row_id) != null ? _ref3 : params.row_id,
        op_type: opType,
        details,
        version: 1,
        fk_parent_id: id === (req == null ? void 0 : req.ncParentAuditId) ? null : req == null ? void 0 : req.ncParentAuditId,
        id
    };
}
/**
 * Extracts metadata related to a specific column for audit logs.
 * Filters and transforms column options based on the column type and data.
 * @param colOptions The column metadata.
 * @returns An object containing extracted column metadata and options.
 */ const extractReqPropsFromColOpt = (colOptions)=>{
    if (!colOptions) return undefined;
    if (Array.isArray(colOptions)) return colOptions.map((col)=>extractReqPropsFromColOpt(col));
    return Object.keys(colOptions).reduce((acc, key)=>{
        if (![
            'id',
            'base_id',
            'source_id',
            'created_by',
            'updated_by',
            'created_at',
            'updated_at',
            'ur',
            'dr',
            'fk_index_name',
            'deleted',
            'fk_target_view_id',
            'fk_workspace_id'
        ].includes(key)) {
            acc[key] = colOptions[key];
        }
        return acc;
    }, {});
};
const extractColMetaForAudit = (column, datas)=>{
    const colOptions = column.colOptions;
    switch(column.uidt || column.field_type){
        // extract meta for column type to render in audit logs
        // add if any custom column info is needed to extract
        // if single of multi select capture only required info
        case _nocodbsdk.UITypes.MultiSelect:
        case _nocodbsdk.UITypes.SingleSelect:
            {
                var _colOptions_options;
                if (colOptions == null ? void 0 : (_colOptions_options = colOptions.options) == null ? void 0 : _colOptions_options.length) {
                    colOptions.options = colOptions.options.filter((opt)=>{
                        return !(datas == null ? void 0 : datas.length) || datas.some((d)=>{
                            var _d_column_title;
                            return (_d_column_title = d[column.title]) == null ? void 0 : _d_column_title.includes(opt.title);
                        });
                    }).map((opt)=>({
                            id: opt.id,
                            title: opt.title,
                            color: opt.color
                        }));
                }
            }
            break;
    }
    // extract meta and other info from colOptions
    return column ? (0, _datatransformationbuilder.columnBuilder)().build(_extends({}, column, {
        // exclude id base_id, created_by, etc... from colOptions
        colOptions: colOptions ? extractReqPropsFromColOpt(colOptions) : undefined
    })) : undefined;
};
const extractRefColumnIfFound = async ({ column, columns, context })=>{
    if (column.uidt === _nocodbsdk.UITypes.Barcode) {
        var _column_colOptions, _columns_find;
        const barcodeValueColumnId = column.fk_barcode_value_column_id || ((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.fk_barcode_value_column_id);
        return {
            barcode_value_field_id: barcodeValueColumnId,
            barcode_value_field_title: (_columns_find = columns.find((c)=>c.id === barcodeValueColumnId)) == null ? void 0 : _columns_find.title
        };
    }
    if (column.uidt === _nocodbsdk.UITypes.QrCode) {
        var _column_colOptions1, _columns_find1;
        const qrCodeValueColumnId = column.fk_qr_value_column_id || ((_column_colOptions1 = column.colOptions) == null ? void 0 : _column_colOptions1.fk_qr_value_column_id);
        return {
            qr_code_value_field_id: qrCodeValueColumnId,
            qr_code_value_field_title: (_columns_find1 = columns.find((c)=>c.id === qrCodeValueColumnId)) == null ? void 0 : _columns_find1.title
        };
    }
    if (column.uidt === _nocodbsdk.UITypes.Button) {
        const hookId = column.fk_webhook_id;
        const hook = hookId && await _models.Hook.get(context, hookId);
        return {
            webhook_id: hookId,
            webhook_title: hook == null ? void 0 : hook.title
        };
    }
    if (column.uidt === _nocodbsdk.UITypes.Lookup) {
        var _column_colOptions2;
        const linkField = columns.find((c)=>{
            var _column_colOptions;
            return c.id === (column.fk_relation_column_id || ((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.fk_relation_column_id));
        });
        const lookupColumnId = column.fk_lookup_column_id || ((_column_colOptions2 = column.colOptions) == null ? void 0 : _column_colOptions2.fk_lookup_column_id);
        const lookupTable = await _models.Model.get(context, linkField.fk_model_id);
        const lookupColumn = await _models.Column.get(context, {
            colId: lookupColumnId
        });
        return {
            link_field_id: linkField == null ? void 0 : linkField.id,
            link_field_title: linkField == null ? void 0 : linkField.title,
            // lookup_table_id: lookupTable?.id,
            // lookup_table_title: lookupTable?.title,
            // lookup_field_id: lookupColumn?.id,
            // lookup_field_title: lookupColumn?.title,
            linked_table_lookup_field_title: lookupColumn == null ? void 0 : lookupColumn.title,
            linked_table_id: lookupTable == null ? void 0 : lookupTable.id,
            linked_table_title: lookupTable == null ? void 0 : lookupTable.title
        };
    }
    if (column.uidt === _nocodbsdk.UITypes.Rollup) {
        var _column_colOptions3;
        const linkField = columns.find((c)=>{
            var _column_colOptions;
            return c.id === (column.fk_relation_column_id || ((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.fk_relation_column_id));
        });
        const rollupColumnId = column.fk_rollup_column_id || ((_column_colOptions3 = column.colOptions) == null ? void 0 : _column_colOptions3.fk_rollup_column_id);
        const rollupTable = await _models.Model.get(context, linkField.fk_model_id);
        const rollupColumn = await _models.Column.get(context, {
            colId: rollupColumnId
        });
        return {
            link_field_id: linkField == null ? void 0 : linkField.id,
            link_field_title: linkField == null ? void 0 : linkField.title,
            // rollup_table_id: rollupTable?.id,
            // rollup_table_title: rollupTable?.title,
            rollup_field_id: rollupColumn == null ? void 0 : rollupColumn.id,
            rollup_field_title: rollupColumn == null ? void 0 : rollupColumn.title,
            linked_table_rollup_field_title: rollupColumn == null ? void 0 : rollupColumn.title,
            linked_table_id: rollupTable == null ? void 0 : rollupTable.id,
            linked_table_title: rollupTable == null ? void 0 : rollupTable.title
        };
    }
    // if Links / LTAR column extract the ref table title and column title
    if ((0, _nocodbsdk.isLinksOrLTAR)(column)) {
        var _column_colOptions4;
        const refTable = await _models.Model.get(context, column.child_id || (column == null ? void 0 : (_column_colOptions4 = column.colOptions) == null ? void 0 : _column_colOptions4.fk_related_model_id));
        let viewInfo = {};
        // extract child view info if defined
        if (column.fk_child_view_id || column.child_view_id) {
            const childView = await _models.View.get(context, column.fk_child_view_id || column.child_view_id);
            viewInfo = {
                child_view_id: childView == null ? void 0 : childView.id,
                child_view_title: childView == null ? void 0 : childView.title
            };
        }
        return _extends({
            ref_table_id: refTable == null ? void 0 : refTable.id,
            ref_table_title: refTable == null ? void 0 : refTable.title
        }, viewInfo);
    }
    return {};
};
const additionalExcludePropsForCol = (_uidt)=>[
        'title',
        'column_name',
        'altered',
        'fk_qr_value_column_id',
        'fk_barcode_value_column_id',
        'fk_relation_column_id',
        'fk_lookup_column_id',
        'fk_rollup_column_id',
        'lookup_column_title',
        'colOptions',
        'rollup_column_title',
        'parent_id',
        'child_column',
        'child_table',
        'child_id',
        'child_table_title',
        'colOptions'
    ];
const metaAliasMap = {
    allowCSVDownload: 'allow_csv_download',
    isLocaleString: 'locale_string',
    duration: 'duration_format',
    is12hrFormat: '12hr_format',
    fk_cover_image_object_fit: 'cover_image_object_fit'
};
const extractViewRelatedProps = async ({ view, context })=>{
    if (!view) return {};
    const result = _extends({}, view);
    parseMetaIfFound({
        payloads: [
            result
        ]
    });
    // extract cover image column id and title
    if (view.fk_cover_image_col_id) {
        const coverImageCol = await _models.Column.get(context, {
            colId: view.fk_cover_image_col_id
        });
        result.cover_image_field_id = coverImageCol == null ? void 0 : coverImageCol.id;
        result.cover_image_field_title = coverImageCol == null ? void 0 : coverImageCol.title;
        result.fk_cover_image_col_id = undefined;
    }
    // extract group by column id and title
    if (view.fk_grp_col_id) {
        const groupByCol = await _models.Column.get(context, {
            colId: view.fk_grp_col_id
        });
        result.group_by_field_id = groupByCol == null ? void 0 : groupByCol.id;
        result.group_by_field_title = groupByCol == null ? void 0 : groupByCol.title;
        result.fk_grp_col_id = undefined;
    }
    // extract calendar group by column id and title
    if (view.calendar_range && Array.isArray(view.calendar_range) && view.calendar_range.length) {
        const columns = await (await _models.Model.get(context, view.fk_model_id)).getColumns(context);
        if (columns) {
            result.calendar_range = view.calendar_range.map((range)=>{
                var _ref, _ref1;
                const fromColumn = columns.find((c)=>c.id === range.fk_from_column_id);
                const toColumn = columns.find((c)=>c.id === range.fk_to_column_id);
                return {
                    from_field_id: fromColumn == null ? void 0 : fromColumn.id,
                    from_field_title: fromColumn == null ? void 0 : fromColumn.title,
                    to_field_id: (_ref = toColumn == null ? void 0 : toColumn.id) != null ? _ref : null,
                    to_field_title: (_ref1 = toColumn == null ? void 0 : toColumn.title) != null ? _ref1 : null
                };
            });
        }
    }
    if (view.fk_prefix_column_id) {
        const prefixCol = await _models.Column.get(context, {
            colId: view.fk_prefix_column_id
        });
        result.prefix_field_id = prefixCol == null ? void 0 : prefixCol.id;
        result.prefix_field_title = prefixCol == null ? void 0 : prefixCol.title;
        result.fk_prefix_column_id = undefined;
    }
    // extract list view level column references
    if (Array.isArray(view.levels) && view.levels.length) {
        result.levels = await Promise.all(view.levels.map(async (level)=>{
            const levelResult = {
                level: level.level,
                enable_nested_records: level.enable_nested_records,
                wrap_headers: level.wrap_headers
            };
            if (level.fk_model_id) {
                const model = await _models.Model.get(context, level.fk_model_id);
                levelResult.model_id = model == null ? void 0 : model.id;
                levelResult.model_title = model == null ? void 0 : model.title;
            }
            if (level.fk_link_column_id) {
                const col = await _models.Column.get(context, {
                    colId: level.fk_link_column_id
                });
                levelResult.link_field_id = col == null ? void 0 : col.id;
                levelResult.link_field_title = col == null ? void 0 : col.title;
            }
            if (level.fk_self_link_column_id) {
                const col = await _models.Column.get(context, {
                    colId: level.fk_self_link_column_id
                });
                levelResult.self_link_field_id = col == null ? void 0 : col.id;
                levelResult.self_link_field_title = col == null ? void 0 : col.title;
            }
            return levelResult;
        }));
    }
    return result;
};
function parseMetaIfFound({ payloads, metaProps = [
    'meta'
], propsToSnakeCase = true }) {
    if (!Array.isArray(payloads)) return;
    for (const payload of payloads){
        if (!payload) continue;
        for (const prop of metaProps){
            if (!payload[prop]) continue;
            if (typeof payload[prop] === 'string') {
                try {
                    payload[prop] = JSON.parse(payload[prop]);
                } catch (unused) {
                // do nothing
                }
            }
            if (typeof payload[prop] === 'object' && propsToSnakeCase) {
                payload[prop] = fromEntries(Object.entries(payload[prop]).map(([key, val])=>{
                    return [
                        key in metaAliasMap ? metaAliasMap[key] : key.replace(/[A-Z]/g, (m)=>`_${m.toLowerCase()}`),
                        val
                    ];
                }));
            }
        }
    }
}
const propsAlias = {
    comparison_op: 'comparison_operator',
    logical_op: 'logical_operator',
    comparison_sub_op: 'comparison_sub_operator'
};
const mapAlias = (payload)=>{
    return fromEntries(Object.entries(payload).map(([key, val])=>{
        return [
            key in propsAlias ? propsAlias[key] : key,
            val
        ];
    }));
};
const populateUpdatePayloadDiff = ({ prev, next, exclude, parseMeta = false, metaProps, excludeNull = false, excludeBlanks = false, replaceAlias = false, boolProps, aliasMap, keepUnderModified = false, keepNested = false })=>{
    if (parseMeta) parseMetaIfFound({
        payloads: [
            next,
            prev
        ],
        metaProps: metaProps
    });
    if (boolProps && Array.isArray(boolProps)) {
        for (const prop of boolProps){
            if (next && prop in next) {
                next[prop] = !!next[prop];
            }
            if (prev && prop in next) {
                prev[prop] = !!prev[prop];
            }
        }
    }
    // if aliasMap is provided, map the alias
    if (aliasMap) {
        // avoid overwriting mapped props
        let mappedProps = new Set();
        next = fromEntries(Object.entries(next).map(([key, val])=>{
            if (key in aliasMap) {
                mappedProps.add(aliasMap[key]);
                return [
                    aliasMap[key],
                    val
                ];
            } else if (mappedProps.has(key)) {
                return undefined;
            }
            return [
                key,
                val
            ];
        }));
        mappedProps = new Set();
        if (!prev) {
            prev = {};
        }
        prev = fromEntries(Object.entries(prev).map(([key, val])=>{
            if (key in aliasMap) {
                mappedProps.add(aliasMap[key]);
                return [
                    aliasMap[key],
                    val
                ];
            } else if (mappedProps.has(key)) {
                return undefined;
            }
            return [
                key,
                val
            ];
        }));
    }
    if (replaceAlias) {
        next = mapAlias(next);
        prev = mapAlias(prev);
    }
    let updatedProps = removeBlankPropsAndMask((0, _deepobjectdiff.diff)(prev, next), exclude, !excludeNull, !excludeBlanks);
    if (!Object.keys(updatedProps).length) return false;
    let prevState;
    if (keepNested) {
        prevState = extractPropsFromPrev(prev, updatedProps);
        updatedProps = extractPropsFromPrev(next, updatedProps);
    } else {
        prevState = (0, _deepobjectdiff.diff)(extractPropsFromPrev(next, updatedProps), extractPropsFromPrev(prev, updatedProps));
    }
    return keepUnderModified ? {
        modifications: updatedProps,
        previous_state: prevState
    } : _extends({}, updatedProps, {
        previous_state: prevState
    });
};
const colAliasMap = {
    rqd: 'required',
    pk: 'primary_key',
    uidt: 'type',
    formula_raw: 'formula',
    title: 'field_titlt',
    id: 'field_id',
    cdf: 'default_value',
    qr_value_field_id: 'qr_value_field_id',
    fk_barcode_value_column_id: 'barcode_value_field_id',
    pv: 'display_value'
};
const ignorePropsInCol = [
    'validate',
    'un',
    'dtx',
    'dt',
    'validate',
    'dtxs',
    'altered',
    'custom',
    'cn',
    'cno',
    'nrqd',
    'unique',
    'au',
    'dtxp',
    'title',
    'column_name',
    'type',
    'userHasChangedTitle',
    'table_name',
    'view_id',
    'fk_model_id',
    'ai',
    'pk',
    'on_update',
    'on_delete',
    'virtual',
    'parsed_tree',
    'formula',
    'system',
    'order',
    'on_update',
    'on_delete',
    'onUpdate',
    'onDelete'
];
const excludeMetaColProps = [
    'defaultViewVolOrder'
];
const transformToSnakeCase = (obj, excludedProps)=>{
    if (!obj || typeof obj !== 'object') return obj;
    let entries = Object.entries(obj);
    if (excludedProps && Array.isArray(excludedProps)) {
        entries = entries.filter(([key])=>{
            return !excludedProps.includes(key);
        });
    }
    return fromEntries(entries.map(([key, val])=>{
        if (key in metaAliasMap) return [
            metaAliasMap[key],
            val
        ];
        return [
            key.replace(/[A-Z]/g, (m)=>`_${m.toLowerCase()}`),
            val
        ];
    }));
};
const filterAndMapAliasToColProps = (payload, excludedMetaProps)=>{
    if (!payload && typeof payload !== 'object') return payload;
    return fromEntries(Object.entries(payload).filter(([key])=>{
        return !ignorePropsInCol.includes(key);
    }).map(([key, val])=>{
        let aliasKey;
        let formattedVal = val;
        if (key in colAliasMap) {
            aliasKey = colAliasMap[key];
        } else {
            aliasKey = key.replace(/[A-Z]/g, (m)=>`_${m.toLowerCase()}`);
        }
        // convert to pascal case
        if (key === 'meta' && val && typeof val === 'object') {
            // remove excluded meta props
            if (val) val = fromEntries(Object.entries(val).filter(([k])=>{
                return !excludeMetaColProps.includes(k) && ![
                    'default_view_col_order',
                    'defaultViewColOrder'
                ].includes(k);
            }));
            if (Object.keys(val).length === 0) {
                formattedVal = undefined;
            } else if ((payload.uidt || payload.field_type) === _nocodbsdk.UITypes.Checkbox) {
                const { icon, iconIdx } = val, rest = _object_without_properties_loose(val, [
                    "icon",
                    "iconIdx"
                ]);
                // extract option meta and include only label and color
                const checkboxMeta = rest;
                if (iconIdx) {
                    var _checkboxIconList_iconIdx;
                    checkboxMeta.icon = (_checkboxIconList_iconIdx = _nocodbsdk.checkboxIconList[iconIdx]) == null ? void 0 : _checkboxIconList_iconIdx.label;
                } else if (icon) {
                    var _checkboxIconList_find;
                    checkboxMeta.icon = (_checkboxIconList_find = _nocodbsdk.checkboxIconList.find((ic)=>ic.checked === (icon == null ? void 0 : icon['checked']))) == null ? void 0 : _checkboxIconList_find.label;
                }
                return [
                    aliasKey,
                    checkboxMeta
                ];
            } else if ((payload.uidt || payload.field_type) === _nocodbsdk.UITypes.Rating) {
                const { icon, iconIdx } = val, rest = _object_without_properties_loose(val, [
                    "icon",
                    "iconIdx"
                ]);
                // extract option meta and include only label and color
                const ratingMeta = rest;
                if (iconIdx) {
                    var _ratingIconList_iconIdx;
                    ratingMeta.icon = (_ratingIconList_iconIdx = _nocodbsdk.ratingIconList[iconIdx]) == null ? void 0 : _ratingIconList_iconIdx.label;
                } else if (icon) {
                    var _ratingIconList_find;
                    ratingMeta.icon = (_ratingIconList_find = _nocodbsdk.ratingIconList.find((ic)=>ic.full === (icon == null ? void 0 : icon['full']))) == null ? void 0 : _ratingIconList_find.label;
                }
                return [
                    aliasKey,
                    ratingMeta
                ];
            } else {
                formattedVal = fromEntries(Object.entries(val).map(([k, v])=>{
                    let aliasKey = k;
                    let val = v;
                    if (k in colAliasMap) aliasKey = key.replace(/[A-Z]/g, (m)=>`_${m.toLowerCase()}`);
                    if (payload.uidt === _nocodbsdk.UITypes.Duration && k === 'duration_format') {
                        var _durationOptions_val;
                        val = (_durationOptions_val = _nocodbsdk.durationOptions[val]) == null ? void 0 : _durationOptions_val.title;
                    }
                    return [
                        aliasKey,
                        val
                    ];
                }));
            }
            return [
                aliasKey,
                transformToSnakeCase(formattedVal, excludedMetaProps)
            ];
        }
        if (key === 'options' && [
            _nocodbsdk.UITypes.MultiSelect,
            _nocodbsdk.UITypes.SingleSelect
        ].includes(payload.uidt)) {
            formattedVal = val.map((opt)=>{
                return (0, _extractProps.extractProps)(opt, [
                    'id',
                    'title',
                    'color',
                    'order'
                ]);
            });
        }
        return [
            aliasKey,
            formattedVal
        ];
    }));
};
function remapWithAlias({ data, columns }) {
    const remapped = {};
    for (const [k, v] of Object.entries(data)){
        const col = columns.find((c)=>c.column_name === k || c.title === k);
        if (col) {
            remapped[col.title] = v;
        }
    }
    return remapped;
}
const excludeAttachmentProps = (obj)=>{
    if (!obj || typeof obj !== 'object') return obj;
    return fromEntries(Object.entries(obj).filter(([key])=>{
        return ![
            'data',
            'signedPath',
            'thumbnails',
            'signedUrl'
        ].includes(key);
    }));
};
const extractAttachmentPropsAndFormat = (obj, props = [
    'banner_image_url',
    'logo_url'
])=>{
    if (!obj || typeof obj !== 'object') return obj;
    return fromEntries(Object.entries(obj).map(([key, val])=>{
        return [
            key,
            props.includes(key) ? excludeAttachmentProps(val) : val
        ];
    }));
};
const extractColsMetaForAudit = (columns, ...datas)=>{
    return columns.filter((col)=>!(0, _nocodbsdk.isSystemColumn)(col)).reduce((acc, col)=>{
        if (!datas.length || datas.some((data)=>data[col.title] !== undefined)) {
            acc[col.title] = extractColMetaForAudit(col, datas);
        }
        return acc;
    }, {});
};
const extractExcludedColumnNames = (columns)=>{
    return columns.reduce((colNames, col)=>{
        if ((0, _nocodbsdk.isSystemColumn)(col) || (0, _nocodbsdk.isVirtualCol)(col)) {
            colNames.push(col.title);
        }
        return colNames;
    }, []);
};
function formatDataForAudit(data, columns) {
    if (!data || typeof data !== 'object') return data;
    const res = {};
    for (const column of columns){
        if ((0, _nocodbsdk.isSystemColumn)(column) || (0, _nocodbsdk.isVirtualCol)(column)) continue;
        if (!(column.title in data)) {
            continue;
        }
        res[column.title] = data[column.title];
        // if multi-select column, convert string to array
        if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
            if (res[column.title] && typeof res[column.title] === 'string') {
                res[column.title] = res[column.title].split(',');
            }
        } else if (column.uidt === _nocodbsdk.UITypes.Attachment) {
            if (res[column.title] && Array.isArray(res[column.title])) {
                try {
                    res[column.title] = res[column.title].map((attachment)=>excludeAttachmentProps(attachment));
                } catch (unused) {
                // ignore
                }
            }
        }
    }
    return res;
}
const generateUpdateAuditV1Payload = async ({ baseModelSqlV2, rowId, oldData, data, req })=>{
    const formattedOldData = formatDataForAudit(oldData, baseModelSqlV2.model.columns);
    const formattedData = formatDataForAudit(data, baseModelSqlV2.model.columns);
    const updateDiff = populateUpdatePayloadDiff({
        keepUnderModified: true,
        prev: formattedOldData,
        next: formattedData,
        exclude: extractExcludedColumnNames(baseModelSqlV2.model.columns),
        excludeNull: false,
        excludeBlanks: false,
        keepNested: true
    });
    if (!updateDiff) {
        return undefined;
    }
    return await generateAuditV1Payload(_nocodbsdk.AuditV1OperationTypes.DATA_UPDATE, {
        context: _extends({}, baseModelSqlV2.context, {
            source_id: baseModelSqlV2.model.source_id,
            fk_model_id: baseModelSqlV2.model.id,
            row_id: typeof rowId === 'string' ? rowId : baseModelSqlV2.extractPksValues(rowId, true)
        }),
        details: {
            old_data: updateDiff.previous_state,
            data: updateDiff.modifications,
            column_meta: extractColsMetaForAudit(baseModelSqlV2.model.columns.filter((c)=>c.title in updateDiff.modifications), data, oldData)
        },
        req
    });
};
